"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const NodeTrees_1 = require("./NodeTrees");
const isPathsGroupNode_1 = __importDefault(require("./isPathsGroupNode"));
const isPathNode_1 = __importDefault(require("./isPathNode"));
const collectNodesByLevel = (rootNodeId, nodesMap, parentsToChildrenMap, level = 0, results = []) => {
    const nodesInPath = NodeTrees_1.getNodeAndDescendants(nodesMap, rootNodeId, isPathsGroupNode_1.default);
    const maybePathNode = lodash_1.first(nodesInPath);
    const pathId = maybePathNode && isPathNode_1.default(maybePathNode) ? maybePathNode.id : undefined;
    nodesInPath.forEach(node => {
        results.push({
            nodeId: node.id,
            level,
            pathId,
        });
    });
    const lastNode = lodash_1.last(nodesInPath);
    if (lastNode && isPathsGroupNode_1.default(lastNode)) {
        const childrenIds = parentsToChildrenMap[lastNode.id] || [];
        childrenIds.forEach((id) => collectNodesByLevel(id, nodesMap, parentsToChildrenMap, level + 1, results));
    }
    return results;
};
const getNodeLevels = (nodesMap) => {
    const rootNode = NodeTrees_1.getRootNode(nodesMap);
    if (!rootNode) {
        return [];
    }
    const parentsToChildrenMap = NodeTrees_1.getParentsToChildrenMap(nodesMap);
    return collectNodesByLevel(rootNode.id, nodesMap, parentsToChildrenMap);
};
exports.default = getNodeLevels;
